import * as _m0 from "protobufjs/minimal";
/** ===================== JoinPoolExecuteMsg */

function createBaseEmptyRequest() {
  return {};
}

export const EmptyRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.EmptyRequest",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmptyRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseEmptyRequest();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return EmptyRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/empty-request",
      value: EmptyRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return EmptyRequest.decode(message.value);
  },

  toProto(message) {
    return EmptyRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.EmptyRequest",
      value: EmptyRequest.encode(message).finish()
    };
  }

};

function createBaseJoinPoolExecuteMsgRequest() {
  return {
    joinPool: undefined
  };
}

export const JoinPoolExecuteMsgRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.JoinPoolExecuteMsgRequest",

  encode(message, writer = _m0.Writer.create()) {
    if (message.joinPool !== undefined) {
      EmptyRequest.encode(message.joinPool, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinPoolExecuteMsgRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.joinPool = EmptyRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseJoinPoolExecuteMsgRequest();
    message.joinPool = object.joinPool !== undefined && object.joinPool !== null ? EmptyRequest.fromPartial(object.joinPool) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      joinPool: object !== null && object !== void 0 && object.join_pool ? EmptyRequest.fromAmino(object.join_pool) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.join_pool = message.joinPool ? EmptyRequest.toAmino(message.joinPool) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return JoinPoolExecuteMsgRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/join-pool-execute-msg-request",
      value: JoinPoolExecuteMsgRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return JoinPoolExecuteMsgRequest.decode(message.value);
  },

  toProto(message) {
    return JoinPoolExecuteMsgRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.JoinPoolExecuteMsgRequest",
      value: JoinPoolExecuteMsgRequest.encode(message).finish()
    };
  }

};

function createBaseJoinPoolExecuteMsgResponse() {
  return {};
}

export const JoinPoolExecuteMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.JoinPoolExecuteMsgResponse",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinPoolExecuteMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseJoinPoolExecuteMsgResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return JoinPoolExecuteMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/join-pool-execute-msg-response",
      value: JoinPoolExecuteMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return JoinPoolExecuteMsgResponse.decode(message.value);
  },

  toProto(message) {
    return JoinPoolExecuteMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.JoinPoolExecuteMsgResponse",
      value: JoinPoolExecuteMsgResponse.encode(message).finish()
    };
  }

};

function createBaseExitPoolExecuteMsgRequest() {
  return {
    exitPool: undefined
  };
}

export const ExitPoolExecuteMsgRequest = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ExitPoolExecuteMsgRequest",

  encode(message, writer = _m0.Writer.create()) {
    if (message.exitPool !== undefined) {
      EmptyRequest.encode(message.exitPool, writer.uint32(10).fork()).ldelim();
    }

    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExitPoolExecuteMsgRequest();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.exitPool = EmptyRequest.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(object) {
    const message = createBaseExitPoolExecuteMsgRequest();
    message.exitPool = object.exitPool !== undefined && object.exitPool !== null ? EmptyRequest.fromPartial(object.exitPool) : undefined;
    return message;
  },

  fromAmino(object) {
    return {
      exitPool: object !== null && object !== void 0 && object.exit_pool ? EmptyRequest.fromAmino(object.exit_pool) : undefined
    };
  },

  toAmino(message) {
    const obj = {};
    obj.exit_pool = message.exitPool ? EmptyRequest.toAmino(message.exitPool) : undefined;
    return obj;
  },

  fromAminoMsg(object) {
    return ExitPoolExecuteMsgRequest.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/exit-pool-execute-msg-request",
      value: ExitPoolExecuteMsgRequest.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ExitPoolExecuteMsgRequest.decode(message.value);
  },

  toProto(message) {
    return ExitPoolExecuteMsgRequest.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ExitPoolExecuteMsgRequest",
      value: ExitPoolExecuteMsgRequest.encode(message).finish()
    };
  }

};

function createBaseExitPoolExecuteMsgResponse() {
  return {};
}

export const ExitPoolExecuteMsgResponse = {
  typeUrl: "/osmosis.cosmwasmpool.v1beta1.ExitPoolExecuteMsgResponse",

  encode(_, writer = _m0.Writer.create()) {
    return writer;
  },

  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExitPoolExecuteMsgResponse();

    while (reader.pos < end) {
      const tag = reader.uint32();

      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },

  fromPartial(_) {
    const message = createBaseExitPoolExecuteMsgResponse();
    return message;
  },

  fromAmino(_) {
    return {};
  },

  toAmino(_) {
    const obj = {};
    return obj;
  },

  fromAminoMsg(object) {
    return ExitPoolExecuteMsgResponse.fromAmino(object.value);
  },

  toAminoMsg(message) {
    return {
      type: "osmosis/cosmwasmpool/exit-pool-execute-msg-response",
      value: ExitPoolExecuteMsgResponse.toAmino(message)
    };
  },

  fromProtoMsg(message) {
    return ExitPoolExecuteMsgResponse.decode(message.value);
  },

  toProto(message) {
    return ExitPoolExecuteMsgResponse.encode(message).finish();
  },

  toProtoMsg(message) {
    return {
      typeUrl: "/osmosis.cosmwasmpool.v1beta1.ExitPoolExecuteMsgResponse",
      value: ExitPoolExecuteMsgResponse.encode(message).finish()
    };
  }

};